import { useContext } from "react";
import { RootContext } from "../contexts/Root";

// Hook to use the root context
export const useRootContext = () => useContext(RootContext); // export const useRootContext = () => useContext(RootContext);
